import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const TOOLS = [["tags", "Tag generator"], ["titles", "Title generator"], ["checker", "SEO checker"]];

export const AdminToolUsage = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/tools/usage").then((r) => setRows(r.data.rows)).catch(() => setRows([])); }, []);
  if (!rows) return null;
  const sum = (tool, f) => rows.filter((r) => r.tool === tool).reduce((n, r) => n + (r[f] || 0), 0);
  return (
    <div data-testid="admin-tool-usage" className="rounded-2xl border border-white/10 bg-white/[0.03] p-5">
      <p className="text-sm font-semibold text-foreground">Free tools usage · last 14 days <span className="font-normal text-muted-foreground">(counts only, no personal data)</span></p>
      <div className="mt-3 grid gap-3 sm:grid-cols-3">
        {TOOLS.map(([k, l]) => (
          <div key={k} data-testid={`admin-tool-usage-${k}`} className="rounded-xl border border-white/10 px-4 py-3 text-sm">
            <p className="text-muted-foreground">{l}</p>
            <p className="mt-1 font-display text-2xl text-foreground">{sum(k, "n")}</p>
            <p className="text-xs text-muted-foreground">{sum(k, "limit_hits")} daily-limit hits · {sum(k, "blocked")} blocked</p>
          </div>
        ))}
      </div>
    </div>
  );
};
